let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bpX6Y")).then(() => parcelRequire('hJmwv'));